import React from 'react'
// import { useTranslation } from 'react-i18next'
import {
  BoxContainer,
  QuestionContainer,
  AnswerContainer,
  ChoiseContainer,
  ChoiseLabelContainer,
  ChoiseLabel,
  OptionLabel,
  QuestionLabel
} from './Question.style'
import { Checkbox } from 'rsuite'

const MultipleChoisesQuestion = ({ data }) => {
  // const { t } = useTranslation()

  return (
    <BoxContainer id="multiple-choises-question">
      <QuestionContainer>
        <QuestionLabel>{data.question}</QuestionLabel>
      </QuestionContainer>
      <AnswerContainer>
        {data.choices.map((item) => {
          return (
            <ChoiseContainer key={item.id}>
              <ChoiseLabelContainer>
                <Checkbox checked={item.value} />
                <ChoiseLabel>{item.text}</ChoiseLabel>
              </ChoiseLabelContainer>
              {item.options && (
                <OptionLabel>{item.options.additionalField.value}</OptionLabel>
              )}
            </ChoiseContainer>
          )
        })}
      </AnswerContainer>
    </BoxContainer>
  )
}

export default MultipleChoisesQuestion
